//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';

export default {
    name: "photos",
    data() {
        return {
            /*photosList: [
                {
                    id: 'photo1',
                    coverImg: require('@/assets/img/cover-1.png'),
                    photoTit: '相册名称1',
                },
                {
                    id: 'photo2',
                    coverImg: require('@/assets/img/cover-2.png'),
                    photoTit: '相册名称2',
                },
                {
                    id: 'photo3',
                    coverImg: require('@/assets/img/cover-3.png'),
                    photoTit: '相册名称3',
                },
                {
                    id: 'photo4',
                    coverImg: require('@/assets/img/cover-4.jpg'),
                    photoTit: '相册名称4',
                },
                {
                    id: 'photo5',
                    coverImg: require('@/assets/img/cover-5.jpg'),
                    photoTit: '相册名称5',
                },
                {
                    id: 'photo6',
                    coverImg: require('@/assets/img/cover-6.png'),
                    photoTit: '相册名称6',
                },
            ],*/
            list: [],
            refreshing: false,
            pageIndex: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            downloadUrl: util.ApiUrl + '/file/download/',
        }
    },
    methods: {
        onLoad() {
            this.pageIndex++;
            this.getPhotoList();
        },
        getPhotoList() {
            this.refreshing = this.pageIndex === 1;
            this.loading = this.pageIndex > 1;
            var page = {
                activityStatus: 1,
                maxResultCount: this.pageSize,
                skipCount: (this.pageIndex - 1) * this.pageSize
            };
            abp.ajax.post('/api/services/app/Album/SearchAlbums', page).then((res) => {
                if (this.pageIndex === 1) {
                    this.list = [];
                }
                this.list.push(...res.data.result.items);
                if (res.data.result.items.length < this.pageSize) {
                    this.finished = true;
                } else {
                    this.finished = false;
                }
            }).finally(() => {
                this.refreshing = false;
                this.loading = false;
            });

        },

    },
    created() {


    }
}
